import { useState } from 'react';
import '../css/Nav design.css';
import upload from '../images/upload_image.png';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import { Oval } from "react-loader-spinner";
import { toast, ToastContainer } from 'react-toastify';
import DocumentRequest from '../model/request/Documentrequest';

function DocumentUploadManualy({ userData, onClose }) {

  // ---------------------------------------------------------
  // LOGIN / ADMIN TOKEN
  // loginVal is used ONLY for authentication/token.
  // It is NOT used as the selected document user's ID.
  // ---------------------------------------------------------
  const rawVal = localStorage.getItem('loginVal');
  const loginVal = rawVal ? JSON.parse(rawVal) : null;
  const token = loginVal?.token || null;

  // ---------------------------------------------------------
  // SELECTED USER ID
  // This is the user selected from Dashboard.
  // ---------------------------------------------------------
  const selectedUserId = userData?.user_Id;

  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [documentList, setDocumentList] = useState([]);

  // ---------------------------------------------------------
  // TOAST
  // ---------------------------------------------------------
  const showToast = (message) => {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  };

  const showToastFailed = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  };

  // ---------------------------------------------------------
  // FILE SELECT
  // ---------------------------------------------------------
  const handleImageChange = (e) => {

    const files = Array.from(e.target.files || []);

    const newImages = files.map((file) => ({
      file: file,
      preview: URL.createObjectURL(file)
    }));

    setImages((prev) => [...prev, ...newImages]);

    // Allow selecting same file again
    e.target.value = "";
  };

  // ---------------------------------------------------------
  // REMOVE SELECTED IMAGE BEFORE UPLOAD
  // ---------------------------------------------------------
  const removeImage = (index) => {

    setImages((prev) =>
      prev.filter((_, i) => i !== index)
    );
  };

  // ---------------------------------------------------------
  // GET DOCUMENT LIST
  // IMPORTANT:
  // userId must always be the selected user's ID.
  // ---------------------------------------------------------
  const documentListAPICall = async (userId = selectedUserId) => {

    if (!userId) {
      console.error("Selected user ID is missing");
      setDocumentList([]);
      return;
    }

    try {

      console.log("================================");
      console.log("GET DOCUMENT LIST");
      console.log("Selected User ID:", userId);
      console.log("================================");

      setIsLoading(true);

      const response = await axios.get(
        ApiConfig.getUrl("User/getDocumentList"),
        {
          params: {
            userId: userId
          },

          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log("Document List Response:", response.data);

      const api = ApiResponse.fromJson(response.data);

      if (api.statusCode === 200 && api.status === true) {

        setDocumentList(api.response || []);

        console.log(
          "Documents loaded for User ID:",
          userId
        );

      } else {

        setDocumentList([]);

        showToastFailed(
          api.message ||
          api.errorMessage ||
          "Document list not found"
        );
      }

    } catch (error) {

      console.error(
        "Get Document List Error:",
        error
      );

      setDocumentList([]);

      showToastFailed(
        error?.response?.data?.message ||
        error?.response?.data?.errorMessage ||
        "Failed to get document list"
      );

    } finally {

      setIsLoading(false);

    }
  };

  // ---------------------------------------------------------
  // UPLOAD DOCUMENT
  // IMPORTANT:
  // UserId = selectedUserId
  // NOT loginVal.user_Id
  // ---------------------------------------------------------
  const handleUpload = async () => {

    if (!selectedUserId) {

      showToastFailed(
        "Selected user not found"
      );

      return;
    }

    if (!images || images.length === 0) {

      showToastFailed(
        "Please select document images"
      );

      return;
    }

    try {

      console.log("================================");
      console.log("DOCUMENT UPLOAD");
      console.log("Selected User ID:", selectedUserId);
      console.log("================================");

      setIsLoading(true);

      const formData = new FormData();

      // IMPORTANT:
      // Selected Dashboard user's ID
      formData.append(
        "UserId",
        selectedUserId
      );

      images.forEach((img) => {

        formData.append(
          "Files",
          img.file
        );

      });

      const response = await axios.post(
        ApiConfig.getUrl(
          "User/manualDocumentUpload"
        ),
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",

            // Admin token ONLY for authorization
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      console.log(
        "Upload Result:",
        response.data
      );

      const api =
        ApiResponse.fromJson(response.data);

      if (
        api.statusCode === 200 &&
        api.status === true
      ) {

        showToast(
          api.message ||
          "Document uploaded successfully"
        );

        // IMPORTANT:
        // Reload selected user's documents
        await documentListAPICall(
          selectedUserId
        );

        setImages([]);

      } else {

        showToastFailed(
          api.message ||
          api.errorMessage ||
          "Document upload failed"
        );
      }

    } catch (error) {

      console.error(
        "Upload Error:",
        error
      );

      showToastFailed(
        error?.response?.data?.message ||
        error?.response?.data?.errorMessage ||
        "Document upload failed"
      );

    } finally {

      setIsLoading(false);

    }
  };

  // ---------------------------------------------------------
  // DOCUMENT STATUS UPDATE
  // userId = selected user
  // updatedBy = Admin
  // ---------------------------------------------------------
  const DocumentVerifiedManualy = async (
    type
  ) => {

    if (!selectedUserId) {

      showToastFailed(
        "Selected user not found"
      );

      return;
    }

    try {

      console.log("================================");
      console.log("DOCUMENT STATUS UPDATE");
      console.log("Selected User ID:", selectedUserId);
      console.log("Updated By Admin ID:", loginVal?.user_Id);
      console.log("Status Type:", type);
      console.log("================================");

      setIsLoading(true);

      const request =
        new DocumentRequest();

      // Selected user whose document is being updated
      request.userId =
        selectedUserId;

      request.type = type;

      // Admin who is performing the update
      request.updatedBy =
        loginVal?.user_Id;

      console.log(
        "Status Request:",
        JSON.stringify(request)
      );

      const response = await axios.put(
        ApiConfig.getUrl(
          "User/doc_checkStatusType"
        ),
        JSON.stringify(request),
        {
          headers: {
            "Content-Type":
              "application/json",

            Authorization:
              `Bearer ${token}`
          }
        }
      );

      console.log(
        "Status Response:",
        response.data
      );

      const api =
        ApiResponse.fromJson(response.data);

      if (api.statusCode === 200) {

        showToast(
          api.response?.message ||
          api.message ||
          "Document status updated successfully"
        );

        // Refresh selected user's documents
        await documentListAPICall(
          selectedUserId
        );

        // Close popup after status update
        if (onClose) {
          onClose();
        }

      } else {

        showToastFailed(
          api.message ||
          api.errorMessage ||
          "Document status update failed"
        );
      }

    } catch (error) {

      console.error(
        "Document Status Update Error:",
        error
      );

      showToastFailed(
        error?.response?.data?.message ||
        error?.response?.data?.errorMessage ||
        "Update failed"
      );

    } finally {

      setIsLoading(false);

    }
  };

  // ---------------------------------------------------------
  // DELETE DOCUMENT
  // IMPORTANT:
  // userId = selected user's ID
  // NOT Admin ID
  // ---------------------------------------------------------
  const documentDeleteAPICall = async (documentId) => {
    if (!selectedUserId) {
      showToastFailed("Selected user not found");
      return;
    }

    if (!documentId) {
      showToastFailed("Document ID not found");
      return;
    }

    try {
      setIsLoading(true);

      console.log("DELETE USER ID:", selectedUserId);
      console.log("DELETE DOCUMENT ID:", documentId);

      const response = await axios.delete(
        ApiConfig.getUrl("User/documentDelete"),
        {
          params: {
            userId: selectedUserId,
            documentId: documentId
          },
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log("DELETE RESPONSE:", response.data);

      const api = ApiResponse.fromJson(response.data);

      if (api.statusCode === 200 && api.status === true) {

        showToast(
          api.message || "Document deleted successfully"
        );

        // selected user-க்கு மட்டும் list refresh
        await documentListAPICall(selectedUserId);

      } else {

        showToastFailed(
          api.message ||
          api.errorMessage ||
          "Document delete failed"
        );
      }

    } catch (error) {

      console.error("DELETE ERROR:", error);
      console.error(
        "DELETE ERROR RESPONSE:",
        error?.response?.data
      );

      showToastFailed(
        error?.response?.data?.message ||
        error?.response?.data?.errorMessage ||
        "Delete failed"
      );

    } finally {
      setIsLoading(false);
    }
  };

  // ---------------------------------------------------------
  // DISABLE RIGHT CLICK
  // ---------------------------------------------------------
  const disableRightClick = (e) => {
    e.preventDefault();
  };

  // ---------------------------------------------------------
  // RENDER
  // ---------------------------------------------------------
  return (
    <>
      <ToastContainer />

      {isLoading && (
        <div
          className="loader-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <Oval
            height={60}
            width={60}
            color="#ffffff"
            secondaryColor="#cccccc"
            strokeWidth={4}
            visible={true}
          />
        </div>
      )}

      <div
        onContextMenu={disableRightClick}
        className="card p-4"
        style={{
          maxWidth: "480px",
          width: "100%",
          borderRadius: "16px",
          boxShadow:
            "0 12px 30px rgba(255, 140, 0, 0.25)"
        }}
      >

        {/* --------------------------------------------- */}
        {/* SELECTED USER */}
        {/* --------------------------------------------- */}

        <div className="text-center mb-3">

          <h5>
            User ID:
            {" "}
            <strong>
              {selectedUserId || "N/A"}
            </strong>
          </h5>

          <p className="text-muted mb-0">
            {userData?.name || ""}
          </p>

        </div>

        {/* --------------------------------------------- */}
        {/* TITLE */}
        {/* --------------------------------------------- */}

        <h3
          className="text-center fw-semibold mb-3"
          style={{
            color: "#ff8c00"
          }}
        >
          📄 Document Upload
        </h3>

        {/* --------------------------------------------- */}
        {/* EMPTY STATE */}
        {/* --------------------------------------------- */}

        {images.length === 0 && (

          <div className="text-center mb-3">

            <img
              src={upload}
              alt="upload"
              style={{
                width: "110px",
                opacity: 0.85
              }}
            />

            <p className="text-muted mt-2 mb-0">
              Upload your document images
            </p>

          </div>
        )}

        {/* --------------------------------------------- */}
        {/* NEW SELECTED IMAGES */}
        {/* --------------------------------------------- */}

        <div
          className="d-flex flex-wrap justify-content-center gap-3 mt-3"
        >

          {images.map((img, index) => (

            <div
              key={index}
              className="position-relative"
              style={{
                width: "120px",
                height: "120px"
              }}
            >

              <img
                src={img.preview}
                alt="doc"
                className="w-100 h-100"
                style={{
                  objectFit: "cover",
                  borderRadius: "12px",
                  boxShadow:
                    "0 4px 10px rgba(255, 140, 0, 0.25)"
                }}
              />

              {/* Remove before upload */}
              <button
                type="button"
                onClick={() =>
                  removeImage(index)
                }
                className="position-absolute top-0 end-0 translate-middle rounded-circle"
                style={{
                  width: "22px",
                  height: "22px",
                  border: "none",
                  background: "#ff4d4f",
                  color: "white",
                  fontSize: "14px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                ×
              </button>

            </div>

          ))}

        </div>

        {/* --------------------------------------------- */}
        {/* FILE INPUT */}
        {/* --------------------------------------------- */}

        <label
          htmlFor="fileUpload"
          className="mt-4 text-center"
          style={{
            display: "block",
            padding: "12px",
            borderRadius: "10px",
            background:
              "linear-gradient(135deg, #ff8c00, #ffa94d)",
            color: "white",
            fontWeight: "500",
            cursor: "pointer",
            boxShadow:
              "0 5px 15px rgba(255, 140, 0, 0.3)"
          }}
        >
          + Add Document Images
        </label>

        <input
          id="fileUpload"
          type="file"
          multiple
          accept="image/*"
          onChange={handleImageChange}
          style={{
            display: "none"
          }}
        />

        {/* --------------------------------------------- */}
        {/* UPLOAD */}
        {/* --------------------------------------------- */}

        <button
          type="button"
          className="mt-3 fw-semibold"
          onClick={handleUpload}
          disabled={
            isLoading ||
            !selectedUserId ||
            images.length === 0
          }
          style={{
            background: "#ff8c00",
            color: "white",
            border: "none",
            borderRadius: "10px",
            padding: "10px",
            width: "100%",
            boxShadow:
              "0 5px 15px rgba(255, 140, 0, 0.35)",
            opacity:
              isLoading ||
                !selectedUserId ||
                images.length === 0
                ? 0.6
                : 1
          }}
        >
          Upload
        </button>

        {/* --------------------------------------------- */}
        {/* DOCUMENT STATUS */}
        {/* --------------------------------------------- */}

        <div className="btn-group m-5">

          <button
            type="button"
            onClick={() =>
              DocumentVerifiedManualy(0)
            }
            disabled={
              isLoading ||
              !selectedUserId
            }
            style={{
              backgroundColor: "green",
              color: "white",
              border: "none",
              padding: "8px 20px"
            }}
          >
            Yes
          </button>

          <button
            type="button"
            onClick={() =>
              DocumentVerifiedManualy(1)
            }
            disabled={
              isLoading ||
              !selectedUserId
            }
            style={{
              backgroundColor: "red",
              color: "white",
              border: "none",
              padding: "8px 20px"
            }}
          >
            No
          </button>

        </div>

        {/* --------------------------------------------- */}
        {/* DOCUMENT LIST */}
        {/* --------------------------------------------- */}

        <div
          className="w-100 mt-5 p-3 d-flex flex-wrap gap-2"
          style={{
            maxHeight: "400px",
            overflowY: "auto"
          }}
        >

          {documentList.length === 0 ? (

            <div
              className="text-center w-100 text-muted"
            >
              No documents found
            </div>

          ) : (

            documentList.map(
              (img, index) => (

                <div
                  key={
                    img.id ||
                    `document-${index}`
                  }
                  className="position-relative"
                  style={{
                    width: "200px",
                    height: "200px"
                  }}
                >

                  <img
                    src={img.documentPath}
                    alt="document"
                    className="img-thumbnail w-100 h-100"
                    style={{
                      objectFit: "cover",
                      borderRadius: "10px",
                      boxShadow:
                        "0 4px 10px rgba(255, 140, 0, 0.25)"
                    }}
                  />

                  {/* -------------------------------- */}
                  {/* DELETE DOCUMENT */}
                  {/* -------------------------------- */}

                  <button
                    type="button"
                    onClick={() => {
                      console.log("Deleting document:", img);
                      console.log("🔥 DELETE BUTTON CLICKED");
                      console.log("FULL IMG:", img);
                      console.log("DOCUMENT ID:", img?.id);
                      console.log("SELECTED USER ID:", selectedUserId);
                      documentDeleteAPICall(img.id);
                    }}
                    disabled={isLoading}
                    className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: "25px",
                      height: "25px",
                      padding: 0
                    }}
                  >
                    ×
                  </button>

                </div>

              )
            )

          )}

        </div>

      </div>
    </>
  );
}

export default DocumentUploadManualy;